module.exports = __webpack_public_path__ + "img/232014_908B78_5E5743_747460-256px.c95ab5c5.png";